import { render } from "./PortalTurnosListadoSeccion.vue?vue&type=template&id=4149e6f2&scoped=true"
import script from "./PortalTurnosListadoSeccion.vue?vue&type=script&lang=js"
export * from "./PortalTurnosListadoSeccion.vue?vue&type=script&lang=js"

import "./PortalTurnosListadoSeccion.vue?vue&type=style&index=0&id=4149e6f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4149e6f2"]])

export default __exports__